



















































































import {Component, Prop, Vue, Watch, Ref, Emit} from 'vue-property-decorator'
import {VueGoodTable} from 'vue-good-table'
import { SlidePanel, Tooltip } from '@frontend/components'
import ArticlesFields from '../ArticlesFields.vue'
import Sortable from '@/directives/sortable'

@Component({
  components: {
    VueGoodTable,
    Tooltip,
    SlidePanel,
    ArticlesFields,
  },
  directives: {
    Sortable,
  },
})
class Articles extends Vue {
  @Prop({type: Object})
  draft!: {steps: {
    articles: {
      articles: any[],
    }
  }}

  @Ref('slide-panel') readonly panel!: {show: any, hide: any}

  editItemIndex = -1
  item = {} as Record<string, any>
  show = true

  tableColumns = [{
    label: '',
    field: 'sort',
  }, {
    label: 'Item',
    field: 'title',
  }, {
    label: '',
    field: 'edit',
  }]

  get wat () {
    return typeof this.articles
  }

  get articles () {
    return this.draft.steps.articles.articles
  }

  setLink (a: any) {
    if (a.article) {
      this.item.link = `${process.env.VUE_APP_INSIGHTS_URL}article/${a.article.slug}`
    }
  }

  editItem (index: number) {
    console.log(index, this.articles)
    this.editItemIndex = index
    this.item = this.articles[index]
    this.panel.show()
  }

  @Emit('update2')
  update (draft: any) {}

  saveItem () {
    const draft = {...this.draft}
    if (this.editItemIndex === -1) {
      draft.steps.articles.articles.push(this.item)
    } else {
      draft.steps.articles.articles[this.editItemIndex] = this.item
    }
    this.update(draft)
    this.panel.hide()
  }

  onItemsSort (sort: {oldIndex: number, newIndex: number}) {
    const draft = {...this.draft}
    const item = draft.steps.articles.articles.splice(sort.oldIndex, 1)
    draft.steps.articles.articles.splice(sort.newIndex, 0, item[0])
    // hack the crap out of this sortable thing
    this.update(draft)
    this.$nextTick(() => {
      this.show = false
      this.$nextTick(() => this.show = true)
    })
  }

  deleteItem (index: number) {
    const draft = {...this.draft}
    draft.steps.articles.articles.splice(index, 1)
    this.update(draft)
  }

  createItem () {
    this.editItemIndex = -1
    this.item = {
      link: '',
      title: '',
      synopsis: '',
    }
    this.panel.show()
  }

}
export default Articles
